export default "__VITE_ASSET__Cygah9mF__"